import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { FamilyMember } from '../../services/familyPlanService';
import { Trash2, UserCheck, Clock } from 'lucide-react';

interface FamilyMemberCardProps {
  member: FamilyMember;
  onRemove: (memberId: number) => void;
  isRemoving: boolean;
}

const FamilyMemberCard: React.FC<FamilyMemberCardProps> = ({ member, onRemove, isRemoving }) => {
  const getStatusBadge = () => {
    switch (member.status) {
      case 'active':
        return <Badge className="bg-green-500"><UserCheck className="w-3 h-3 mr-1" /> Active</Badge>;
      case 'pending':
        return <Badge variant="outline"><Clock className="w-3 h-3 mr-1" /> Pending</Badge>;
      case 'removed':
        return <Badge variant="destructive">Removed</Badge>;
      default:
        return <Badge variant="secondary">{member.status}</Badge>;
    }
  };

  return (
    <Card className="w-full">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <p className="font-medium">{member.member_email || 'Unknown'}</p>
              {getStatusBadge()}
            </div>
            <p className="text-sm text-muted-foreground">
              Added: {new Date(member.added_at).toLocaleDateString()}
            </p>
            {member.status === 'pending' && (
              <p className="text-sm text-yellow-600 mt-1">
                Waiting for user to sign up
              </p>
            )}
          </div>
          {member.status !== 'removed' && (
            <Button
              variant="destructive"
              size="sm"
              onClick={() => onRemove(member.id)}
              disabled={isRemoving}
            >
              <Trash2 className="w-4 h-4 mr-1" />
              Remove
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default FamilyMemberCard;
